import noUiSlider from 'nouislider';
export class Country {
  constructor({ CountryName, CultureId, IsoCode2, CheckboxId }) {
    this.name = CountryName;
    this.id = CultureId;
    this.isoCode2 = IsoCode2;
    this.checkboxId = CheckboxId;
  }
}

export class Category {
  constructor({ CategoryName, CategoryId, CheckboxId }) {
    this.name = CategoryName;
    this.id = CategoryId;
    this.checkboxId = CheckboxId;
  }
}

export class Location {
  constructor({ CultureId, CategoryId, LocationId, LocationName }) {
    this.name = LocationName;
    this.id = String(LocationId);
    this.checkboxId = String(LocationId);
    this.country = String(CultureId);
    this.category = String(CategoryId);
  }
}

export class Amenity {
  constructor({ CultureId, CategoryId, AmenityId, AmenityName, NumberOfLots }) {
    this.name = AmenityName;
    this.id = String(AmenityId);
    this.checkboxId = String(AmenityId);
    this.country = String(CultureId);
    this.category = String(CategoryId);
    this.numberOfLots = NumberOfLots;
  }
}

export class PropertyType {
  constructor({
    CultureId,
    CategoryId,
    PropertyTypeId,
    PropertyTypeName,
    NumberOfLots,
  }) {
    this.name = PropertyTypeName;
    this.id = String(PropertyTypeId);
    this.checkboxId = String(PropertyTypeId);
    this.country = String(CultureId);
    this.category = String(CategoryId);
    this.numberOfLots = NumberOfLots;
  }
}

const FIELDS = {
  CATEGORIES: 'categories',
  COUNTRIES: 'countries',
  LOCATIONS: 'locations',
  PRICE: 'price',
  PROPERTY_TYPE: 'propertyTypes',
  BEDS: 'beds',
  SORT: 'sort',
};

const CATEGORIES = {
  RESIDENTIAL: '80',
  COMMERCIAL: '77',
};

const SIDE_FILTERS = [
  'division',
  'entitytype',
  'region',
  'location',
  'propertytypes',
  'minbed',
  'maxprice',
  'minprice',
  'sort',
  'keyword',
  'agency',
];

const BEDS_OPTIONS = {
  Any: 0,
  '1+': 1,
  '2+': 2,
  '3+': 3,
  '4+': 4,
  '5+': 5,
};

function reverseObj(obj) {
  if (typeof Object.fromEntries === 'function') {
    return Object.fromEntries(Object.entries(obj).map((a) => a.reverse()));
  } else {
    // Fallback for some browsers
    const newObj = {};
    Object.keys(obj).forEach((key) => {
      newObj[obj[key]] = key;
    });
    return newObj;
  }
}

const BEDS_OPTIONS_REVERSE = reverseObj(BEDS_OPTIONS);

const COUNTRIES = {
  SPAIN: '5',
  SOUTH_AFRICA: '3',
};

const PRICE_RANGE_PER_COUNTRY = {
  [COUNTRIES.SOUTH_AFRICA]: {
    MIN_PRICE: 0,
    MAX_PRICE: 20000000,
  },
  DEFAULT: {
    MIN_PRICE: 0,
    MAX_PRICE: 5000000,
  },
};

export const CURRENCIES_PER_COUNTRY = {
  1: 'EUR',
  2: 'GBP',
  3: 'ZAR',
  4: 'EUR',
  5: 'EUR',
};

export default (options, emptyLabel, staticFilters = {}) => ({
  init() {
    this.filtersSidePanelOpen = false;
    this.selected = this.fromStaticFilters(staticFilters);
    this.selected = this.fromQueryString(document.location.search);
    this.filterLocationOptions();
    this.$watch(
      'selected.countries, selected.categories, locationsSearch',
      () => this.filterLocationOptions()
    );
    this.filterPropertyTypesOptions();
    this.$watch('selected.countries', () => this.filterPropertyTypesOptions());
    this.$watch('selected.price.max', () =>
      this.addThousandsSeparatorToMaxPrice()
    );
    this.$watch('selected.price.min', () =>
      this.addThousandsSeparatorToMinPrice()
    );
    this.sortUrls = {};
  },
  emptyLabel: emptyLabel,
  options: {
    categories: options.categories.map((category) => new Category(category)),
    countries: options.countries.map((country) => new Country(country)),
    locations: options.locations.map((location) => new Location(location)),
    beds: null,
    amenities: options.amenities.map((amenity) => new Amenity(amenity)),
    propertyTypes: options.property_types.map(
      (propertyType) => new PropertyType(propertyType)
    ),
  },
  filteredLocations: [],
  filteredPropertyTypes: [],
  selected: {
    categories: [],
    countries: [],
    locations: [],
    amenities: [],
    propertyTypes: [],
    beds: null,
    price: {
      max: PRICE_RANGE_PER_COUNTRY.DEFAULT.MAX_PRICE,
      min: PRICE_RANGE_PER_COUNTRY.DEFAULT.MIN_PRICE,
    },
    agency: '',
    auctionids: '',
  },
  display: {
    price: {
      min: 0,
      max: 0,
    },
  },
  locationsSearch: '',
  showMore: false,
  get queryString() {
    return this.selected;
  },
  get isAgencyPage() {
    return !!this.selected.agency;
  },
  isChecked: function (field, value) {
    return this.selected[field].includes(value);
  },
  removeField: function (field, value) {
    this.selected[field] = this.selected[field].filter((a) => a != value);
  },
  toggleField: function (field, value) {
    if (field === FIELDS.BEDS) {
      this.selected[field] = value;
    } else {
      if (this.isChecked(field, value)) {
        this.removeField(field, value);
      } else {
        this.selected[field].push(value);
      }
    }
  },
  onlySpainSelected: function () {
    return (
      this.selected[FIELDS.COUNTRIES].length === 1 &&
      this.selected[FIELDS.COUNTRIES].includes(COUNTRIES.SPAIN)
    );
  },
  isBedsEnabled: function () {
    return (
      this.selected[FIELDS.CATEGORIES].includes(CATEGORIES.RESIDENTIAL) ||
      this.selected[FIELDS.CATEGORIES].length === 0
    );
  },
  locationsCount: function () {
    return this.filteredLocations.length;
  },
  filterLocationOptions: function () {
    let filteredLocations = this.options.locations;

    // Filter by countries
    if (this.selected.countries.length > 0) {
      filteredLocations = filteredLocations.filter((location) =>
        this.selected.countries.includes(location.country)
      );
    }
    // Filter by categories
    if (this.selected.categories.length > 0) {
      const categoriesToFilter = [...this.selected.categories];
      filteredLocations = filteredLocations.filter((location) =>
        categoriesToFilter.includes(location.category)
      );
    }
    // Filter by string
    if (this.locationsSearch) {
      filteredLocations = filteredLocations.filter((location) =>
        location.name.toUpperCase().includes(this.locationsSearch.toUpperCase())
      );
    }
    filteredLocations = filteredLocations.map((location) =>
      location.id.toString()
    );
    // Remvove selected locations that are not appering anymore
    this.selected[FIELDS.LOCATIONS] = this.selected[
      FIELDS.LOCATIONS
    ].filter((selectedLocation) =>
      filteredLocations.includes(selectedLocation)
    );
    this.filteredLocations = [...new Set(filteredLocations)];
  },
  shouldDisplay: function (field, value) {
    if (field === FIELDS.LOCATIONS) {
      let filteredLocations = this.filteredLocations;
      if (!this.showMore) {
        filteredLocations = filteredLocations.slice(0, 6);
      }
      return filteredLocations.includes(value);
    } else if (field === FIELDS.PROPERTY_TYPE) {
      return this.filteredPropertyTypes.includes(value);
    }
    return true;
  },
  getDisplayLabel: function (field) {
    if (field === FIELDS.PRICE) return this.getDisplayPriceLabel();

    if (
      field === FIELDS.PROPERTY_TYPE &&
      this.selected[field].length === 0 &&
      this.selected[FIELDS.CATEGORIES].length > 0
    ) {
      field = FIELDS.CATEGORIES;
    }
    const selectedFilters = this.selected[field];
    if (field == FIELDS.BEDS) {
      if (selectedFilters === null || selectedFilters === 'Any') {
        return this.emptyLabel;
      }
      return selectedFilters;
    }
    const selectedOptionsCount = selectedFilters.length;
    if (selectedOptionsCount > 0) {
      const firstSelectedOption = this.options[field].find(
        (option) => option.id == selectedFilters[0]
      ).name;
      return selectedOptionsCount > 1
        ? `${firstSelectedOption} (+${selectedOptionsCount - 1})`
        : firstSelectedOption;
    }
    return this.emptyLabel;
  },
  initializeSliderElement: function () {
    this.$slider = noUiSlider.create(this.$refs.priceRangeSlider, {
      start: [this.selected.price.min, this.selected.price.max],
      connect: true,
      range: {
        max: this.getMaxPriceRange(),
        min: this.getMinPriceRange(),
      },
      tooltips: {
        to: this.formatterTo,
        from: (value) => {
          return Number(value.replace(',-', ''));
        },
      },
      format: {
        to: (value) => {
          return value.toFixed(0);
        },
        from: (value) => {
          return Number(value.replace(',-', ''));
        },
      },
      step: 1000,
    });
    this.$slider.on('update', this.setPrice.bind(this));
  },
  formatterTo: function (value) {
    const suffix = value === this.rangeMaxValue ? '+' : '';
    const fullInt = value % 1_000_000 === 0;
    return value < 1_000_000
      ? `${Math.floor(value / 1_000)}k`
      : `${(value / 1_000_000).toFixed(fullInt ? 0 : 3)}m${suffix}`;
  },
  getDisplayPriceLabel: function () {
    if (!this.isPriceEnabled) return this.emptyLabel;
    if (
      this.selected.price.max != this.getMaxPriceRange() &&
      this.selected.price.min != this.getMinPriceRange()
    ) {
      return `${this.formatterTo(this.selected.price.min)} - ${this.formatterTo(
        this.selected.price.max
      )}`;
    } else if (this.selected.price.max != this.getMaxPriceRange()) {
      return `<${this.formatterTo(this.selected.price.max)}`;
    } else if (this.selected.price.min != this.getMinPriceRange()) {
      return `${this.formatterTo(this.selected.price.min)}+`;
    }
    return this.emptyLabel;
  },
  addThousandsSeparatorToMaxPrice: function () {
    this.display.price.max = this.addThousandsSeparator(
      this.selected.price.max
    );
  },
  addThousandsSeparatorToMinPrice: function () {
    this.display.price.min = this.addThousandsSeparator(
      this.selected.price.min
    );
  },
  addThousandsSeparator: function (value) {
    if (typeof value === 'number') value = value.toString();
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  },
  removeNonNumericCharacters: function (value) {
    if (typeof value === 'number') value = value.toString();
    return value.replace(/\D/g, '');
  },
  setPrice: function (values) {
    this.selected.price.min = values[0];
    this.selected.price.max = values[1];
  },
  inputPreChange: function (event) {
    const isNumber = isFinite(event.key);
    if (isNumber === false || event.key === ' ') {
      if (event.key.length > 1) return;
      event.stopPropagation();
      event.preventDefault();
      return false;
    }
  },
  inputChange: function (event, field) {
    this.display.price[field] = this.addThousandsSeparator(
      this.removeNonNumericCharacters(event.target.value)
    );
  },
  setSlider: function () {
    this.selected.price.max = parseInt(
      this.removeNonNumericCharacters(this.display.price.max)
    );
    this.selected.price.min = parseInt(
      this.removeNonNumericCharacters(this.display.price.min)
    );
    this.$slider.set([this.selected.price.min, this.selected.price.max]);
  },
  updateSliderRange: function (field) {
    if (this.$slider === undefined || field != FIELDS.COUNTRIES) return;
    this.$slider.updateOptions({
      range: { min: this.getMinPriceRange(), max: this.getMaxPriceRange() },
    });
    if (this.selected.price.max == PRICE_RANGE_PER_COUNTRY.DEFAULT.MAX_PRICE) {
      this.$slider.set([this.selected.price.min, this.getMaxPriceRange()]);
    }
  },
  updateAssociatedFields: function (field, name) {
    if (field === FIELDS.PROPERTY_TYPE) {
      let propertyType = this.options.propertyTypes.find((c) => c.id == name);
      let categoryId = propertyType.category;
      if (
        !this.selected.categories.includes(categoryId) &&
        this.isChecked(field, name)
      ) {
        // if category of the property type is not select, include on selected fields
        this.selected.categories.push(categoryId);
      }
    }
    // when deselect a category should deselect all property types too
    else if (field == FIELDS.CATEGORIES && !this.isChecked(field, name)) {
      let propertyTypesToBeDropped = this.options.propertyTypes.filter(
        (propertyType) =>
          propertyType.category == name &&
          this.selected.propertyTypes.includes(propertyType.id)
      );

      let propertyTypesIdsToBeDropped = propertyTypesToBeDropped.map(
        (propertyType) => {
          return propertyType.id;
        }
      );

      this.selected.propertyTypes = this.selected.propertyTypes.filter(
        (propertyTypeId) =>
          !propertyTypesIdsToBeDropped.includes(propertyTypeId)
      );
    }
  },
  getMaxPriceRange: function () {
    return this.selected.countries.includes(COUNTRIES.SOUTH_AFRICA)
      ? PRICE_RANGE_PER_COUNTRY[COUNTRIES.SOUTH_AFRICA].MAX_PRICE
      : PRICE_RANGE_PER_COUNTRY.DEFAULT.MAX_PRICE;
  },
  getMinPriceRange: function () {
    return this.selected.countries.includes(COUNTRIES.SOUTH_AFRICA)
      ? PRICE_RANGE_PER_COUNTRY[COUNTRIES.SOUTH_AFRICA].MIN_PRICE
      : PRICE_RANGE_PER_COUNTRY.DEFAULT.MIN_PRICE;
  },
  get isPriceEnabled() {
    const currencies = this.selected.countries
      .map((country) => CURRENCIES_PER_COUNTRY[country])
      .filter((value, index, self) => self.indexOf(value) === index);
    return currencies.length === 1;
  },
  SelectedFiltersToQueryString: function () {
    return this.toQueryString(this.selected);
  },
  toQueryString: function (filters) {
    const params = new URLSearchParams();
    const selected_divisions = filters.categories;
    if (selected_divisions && selected_divisions.length > 0)
      params.append('division', selected_divisions.join(','));
    if (filters.countries && filters.countries.length > 0)
      params.append('region', filters.countries.join(','));
    if (filters.locations && filters.locations.length > 0)
      params.append('location', filters.locations.join(','));
    if (filters.propertyTypes && filters.propertyTypes.length > 0)
      params.append('propertytypes', filters.propertyTypes.join(','));
    if (filters.beds && this.isBedsEnabled()) {
      if (BEDS_OPTIONS[filters.beds] !== 0) {
        params.append('minbed', BEDS_OPTIONS[filters.beds] ?? 0);
      }
    }
    if (this.shouldDisableAmenities() && filters.amenities.length > 0)
      params.append('amenities', filters.amenities.join(','));
    if (
      this.isPriceEnabled &&
      (filters.price.max != this.getMaxPriceRange() ||
        filters.price.min != this.getMinPriceRange())
    ) {
      params.append('maxprice', filters.price.max);
      params.append('minprice', filters.price.min);
    }
    if (filters.keyword) {
      params.append('keyword', filters.keyword);
    }
    if (filters.sort) {
      params.append('sort', filters.sort);
    }
    if (filters.agency) {
      params.append('agency', filters.agency);
    }
    if (this.isAgencyPage && filters.auctionids) {
      params.append('auctionids', filters.auctionids);
    }
    return params.toString().replace(/%2C/g, ',');
  },
  fromQueryString: function (queryString) {
    const params = new URLSearchParams(queryString);
    function shouldUseParam(param) {
      return params.has(param) && params.get(param) !== '';
    }
    const categories = shouldUseParam('division')
      ? params.get('division').split(',')
      : this.selected.categories;
    if (shouldUseParam('entitytype') && params.get('entitytype').includes('3'))
      categories.push('3');
    return {
      categories: categories,
      countries: shouldUseParam('region')
        ? params.get('region').split(',')
        : this.selected.countries,
      locations: shouldUseParam('location')
        ? params.get('location').split(',')
        : [],
      amenities: shouldUseParam('amenities')
        ? params.get('amenities').split(',')
        : [],
      propertyTypes: shouldUseParam('propertytypes')
        ? params.get('propertytypes').split(',')
        : [],
      beds: shouldUseParam('minbed')
        ? BEDS_OPTIONS_REVERSE[params.get('minbed')]
        : 'Any',
      price: {
        max: shouldUseParam('maxprice')
          ? parseInt(params.get('maxprice'))
          : this.getMaxPriceRange(0),
        min: shouldUseParam('minprice')
          ? parseInt(params.get('minprice'))
          : this.getMinPriceRange(),
      },
      sort: shouldUseParam('sort') ? params.get('sort') : '',
      keyword: shouldUseParam('keyword') ? params.get('keyword') : '',
      agency: shouldUseParam('agency')
        ? params.get('agency')
        : this.selected.agency,
      auctionids: shouldUseParam('auctionids')
        ? params.get('auctionids')
        : this.selected.auctionids || '',
    };
  },
  fromStaticFilters: function (staticFilters) {
    const categories = staticFilters.hasOwnProperty('division')
      ? staticFilters.division.split(',')
      : this.selected.categories;
    if (
      staticFilters.hasOwnProperty('entitytype') &&
      staticFilters.entitytype.includes('3')
    )
      categories.push('3');
    return {
      categories: categories,
      countries: staticFilters.hasOwnProperty('region')
        ? staticFilters.region.split(',')
        : this.selected.countries,
      locations: [],
      amenities: [],
      propertyTypes: [],
      beds: null,
      price: {
        max: PRICE_RANGE_PER_COUNTRY.DEFAULT.MAX_PRICE,
        min: PRICE_RANGE_PER_COUNTRY.DEFAULT.MIN_PRICE,
      },
      agency: staticFilters.agency || '',
      auctionids: staticFilters.auctionids || '',
    };
  },
  filterPropertyTypesOptions: function () {
    let filteredPropertyTypes = this.options.propertyTypes;

    // Filter by countries
    if (this.selected.countries.length > 0) {
      filteredPropertyTypes = filteredPropertyTypes.filter((propertyTypes) =>
        this.selected.countries.includes(propertyTypes.country)
      );
    }
    filteredPropertyTypes = filteredPropertyTypes.map((propertyType) =>
      propertyType.id.toString()
    );
    // Remvove selected proeprty types that are not appering anymore
    this.selected[FIELDS.PROPERTY_TYPE] = this.selected[
      FIELDS.PROPERTY_TYPE
    ].filter((selectedPropertyType) =>
      filteredPropertyTypes.includes(selectedPropertyType)
    );
    this.filteredPropertyTypes = filteredPropertyTypes;
  },
  shouldDisableAmenities: function () {
    if (this.selected[FIELDS.CATEGORIES].length === 0) {
      return false;
    }
    if (this.selected[FIELDS.CATEGORIES].length === 1) {
      return !this.selected[FIELDS.CATEGORIES].includes(CATEGORIES.RESIDENTIAL);
    }
    return true;
  },
  clearFilters: function () {
    const agency = this.selected.agency;
    const auctionids = agency ? this.selected.auctionids : '';
    this.selected = {
      categories: [],
      countries: [],
      locations: [],
      amenities: [],
      propertyTypes: [],
      beds: null,
      price: {},
      agency: agency,
      auctionids: auctionids,
    };
    this.selected.price = {
      max: this.getMaxPriceRange(),
      min: this.getMinPriceRange(),
    };
    this.locationsSearch = '';
    this.showMore = false;
    this.updateSliderRange(FIELDS.COUNTRIES);
    if (this.$slider === undefined) return;
    this.$slider.set([this.getMinPriceRange(), this.getMaxPriceRange()]);
  },
  addFilterToUrl: function (urlParams, newParams) {
    // Convert query string to side filters object
    var filters = this.fromQueryString(urlParams);
    // Add or update each parameter from newParams
    Object.entries(newParams).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        filters[key] = value;
      }
    });
    const sideFilters = this.toQueryString(filters);
    const extraParams = this.getExtraParamsQueryString(urlParams);
    return sideFilters + (sideFilters && extraParams ? '&' : '') + extraParams;
  },
  getExtraParamsQueryString: function (urlParams) {
    // check if there is any extra params in the url that are not in the current filters
    const params = new URLSearchParams(urlParams);
    const extraParams = {};
    params.forEach((value, key) => {
      if (!SIDE_FILTERS.includes(key)) {
        extraParams[key] = value;
      }
    });
    return new URLSearchParams(extraParams).toString().replace(/%2C/g, ',');
  },
  getSortUrl: function (urlParams, sort) {
    if (this.sortUrls[sort]) {
      return this.sortUrls[sort];
    }
    this.sortUrls[sort] = '?' + this.addFilterToUrl(urlParams, { sort: sort });
    return this.sortUrls[sort];
  },
  getKeywordUrl: function (urlParams, keyword) {
    return '?' + this.addFilterToUrl(urlParams, { keyword: keyword });
  },
});
